<h2 mat-dialog-title>REMOVE THERAPIST FROM EVENT</h2>
<mat-dialog-content>
    Would you like to remove the therapist from the event?
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row w-100 mx-0">
        <div class="col-6">
            <button mat-button class="w-100" color="warn" [mat-dialog-close]="true">Remove</button>

        </div>
        <div class="col-6">
            <button mat-flat-button class="w-100" color="primary" mat-dialog-close cdkFocusInitial>Cancel</button>

        </div>
    </div>
</mat-dialog-actions>